import type { PropsWithChildren, HTMLAttributes } from 'react';

import clsx from 'clsx';

import styles from './Menu.module.scss';
import type { DesktopLayout, MobileLayout, Visibility } from './types';

type Props = PropsWithChildren<
  HTMLAttributes<HTMLElement> & {
    mobile: MobileLayout;
    desktop: DesktopLayout;
    visibility?: Visibility;
  }
>;

const Menu = ({ children, className, mobile, desktop, visibility, ...rest }: Props) => {
  return (
    <nav
      className={clsx(styles.container, className)}
      data-mobile={mobile}
      data-desktop={desktop}
      data-visibility={visibility}
      {...rest}>
      {children}
    </nav>
  );
};

export default Menu;
